import 'babel-polyfill';
import Vue from 'vue';
import VueRouter from 'vue-router';
// import App from './App.vue';
import Empty from './Empty.vue';
import vuetify from './plugins/vuetify';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import routes from './router';
import './assets/style/index.css';
import logo from './components/Logo';
import info from './components/info.vue';
import lay1 from './components/lay1.vue';
import ubutton from './components/ubutton.vue';
import uinput from './components/uinput.vue';
import uselect from './components/uselect.vue';
import uradio from './components/uradio.vue';
import ulogo from './components/ulogo.vue';
import card from './components/card.vue';
import uedit from './components/edit.vue';
import uwhatsapp from './components/whatsapp.vue';
import amt from './components/amt.vue';
import fps from './components/fps.vue';
import i18n from './i18n.js';
import service from './service.js';
import VueAMap from 'vue-amap';
import toast from './plugins/toast/toast';
// import LetItSnow from 'vue-let-it-snow';
import VueYouTubeEmbed from 'vue-youtube-embed';


Vue.use(VueYouTubeEmbed);
// Vue.use(LetItSnow);
Vue.use(toast);
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: 'YOUR_KEY',
  plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType'],
  v: '1.4.4'
});
Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(VueRouter);

// 这算是一个比较经典的报错了，属于路由重复点击引起的（即自己跳转自己）固定写法：
const originaPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originaPush.call(this, location).catch(err => err)
}

localStorage.setItem('page', 1);
// const i18n = new VueI18n({
//   locale: localStorage.getItem('locale') || 'zh', // 设置地区
//   fallbackLocale: 'en',
//   messages, // 设置地区信息
// });
const router = new VueRouter({
  routes
});
router.beforeEach((to, from, next) => {
  // search 和detail不会重置search页面的page，进入其他页面则重置
  const reaminPage = ['search', 'detail'];
  if(!reaminPage.find((item) => to.path.indexOf('/'+item) === 0)) {
    localStorage.setItem('page', 1);
  }

  const needToken = ['payment', 'renew', 'person'];
  if (needToken.find((item) => to.path.indexOf('/'+item) === 0)) {
    service.my().then(() => {
      next();
    }); // check wether should jump to signin
  } else {
    next();
  }
});
Vue.component('logo', logo);
Vue.component('uinfo', info);
Vue.component('lay1', lay1);
Vue.component('ubutton', ubutton);
Vue.component('uinput', uinput);
Vue.component('uselect', uselect);
Vue.component('uradio', uradio);
Vue.component('ulogo', ulogo);
Vue.component('card', card);
Vue.component('uedit', uedit);
Vue.component('uwhatsapp', uwhatsapp);
Vue.prototype.$service = service;
const number1 = 85261313331;
const number2 = 85260361888;
const number3 = 85251604299;
Vue.prototype.goWhatsappPay =  () => window.open(`https://wa.me/${number1}`);
Vue.prototype.goWhatsapp =  () => window.open(`https://wa.me/${number2}`);
Vue.prototype.goWhatsappAbout =  () => window.open(`https://wa.me/${number3}`);
Vue.prototype.goFB =  () => window.open('https://www.facebook.com/GoldenWinEmploymentAgencyLtd/');
Vue.prototype.$top = () => {
  // window.scrollTo(0,0);
  document.body.scrollTop = 0;
  // document.body.scrollTop(0, 0);
};
Vue.directive('correctDisplay', (s) => {
    return /(undefined|null|-\/|\/-|^$)/.test(s) ? '-' : s;
});

export const v = new Vue({
  i18n,
  router,
  vuetify,
  render: h => h(Empty)
}).$mount('#app');
